import { connect } from 'react-redux';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import mobile from 'is-mobile';
import { DashboardCard } from 'module-tsl-resource-components';
import { emitClick } from '../../modules/Mz';

@connect(null, { emitClick })
export default class DownloadRow extends Component {
  render() {
    const { resource } = this.props;
    const resourceId = resource._id; // eslint-disable-line no-underscore-dangle
    const ratingLink = resource.reviewed ? `/teaching-resource/resource-${resourceId}#reviews`
      : `/my-resources/reviews?resources=${resourceId}`;

    const licence = resource.transaction
      ? { code: resource.transaction.licence, description: resource.transaction.licenceDescription }
      : { code: resource.licence, description: resource.licenceDescription };

    const schoolLicenceUpgradeButtonUrl = `/teaching-resource/checkout/${resourceId}/upgrade`;

    return <DashboardCard
      key={resourceId.toString()}
      cardType='resource'
      resourceUrl={resource.url}
      resourceId={resourceId.toString()}
      authorUsername={resource.authorUsername}
      date={moment(resource.date).format('DD MMM YYYY')}
      licenceCode={licence.code}
      licenceTooltip={licence.description}
      owns={true}
      title={resource.title}
      noRatingButtons
      noDeleteButton
      noDownloadButton={mobile() || resource.isBundleSale}
      rating={true}
      ratingStarColor={resource.reviewed ? 'yellow' : 'light-gray'}
      ratingValue={resource.reviewed ? resource.myRating : 5}
      ratingLabelText={resource.reviewed ? 'You rated this resource: ' : 'Rate this resource: '}
      onRatingStarClick={(num) => {
        this.props.emitClick(`rate-resource-${num}`, resourceId);
        document.location.href = ratingLink;
      }}
      onRatingLabelClick={() => {
        this.props.emitClick('rate-resource', resourceId);
        document.location.href = ratingLink;
      }}
      downloadButtonHref={resource.downloadUrl}
      onDownloadButtonClick={() => {
        this.props.emitClick('download-resource', resourceId);
      }}
      isSchoolLicenceUpgradeAvailable={resource.isSchoolLicenceUpgradeAvailable}
      schoolLicenceUpgradeButtonUrl={schoolLicenceUpgradeButtonUrl}
      licences={resource.allLicences}
    />;
  }
}

DownloadRow.propTypes = {
  emitClick: PropTypes.func,
  resource: PropTypes.object,
};
